import { getQueryParamsValue } from '@/helpers/AppHelpers';

// Product Source Info
// Specs: https://lotoquebec.atlassian.net/browse/SWSPC-1093
export const ProductSourceInfo = {
  PRODUCT_SOURCE: 'product_source',
  LT: 'LT', // Loteries => siteId=LT (Loteries)
  PR: 'PR', // Loteries Promo 2è chance => siteId=SDPR (Promotion SplashDot)
  PS: 'PS', // Loteries Promo SLD Sors du lot => siteId=PS (Promotion SplashDot)
  LB: 'LB', // MOJ+ Web => siteId=MJTP (Mise-o-Jeu Plus web)
  MB: 'MB', // MOJ+ Mobile => siteId=MJTM (Mise-o-Jeu Plus Mobile)
  MA_LT: 'MA_LT', // Loterie App => siteId=MALT (App mobile-par compteApp)
  MP: 'MP', // Loteries App => MAPR (App mobile-promo 2è chance)
  MA: 'MA', // Loteries App => MAREG (App mobile Loteries - Inscription)
  MJ: 'MJ', // MOJ+ App => MJ (App mobile MOJ+ - Inscription)
  MA_MJ: 'MA_MJ', // MOJ+ App => siteId=MAMJ (App mobile-Mise-o-Jeu Plus)
  MA_CA: 'MA_CA', // Casino App => siteId=MACA (App mobile-Casino) *** 2024: POC Casino seulement ***
};

export const arrInAppMobile = [
  ProductSourceInfo.MA,
  ProductSourceInfo.MA_LT,
  ProductSourceInfo.MP,
  ProductSourceInfo.MJ,
  ProductSourceInfo.MA_MJ,
  ProductSourceInfo.MA_CA,
];
export const arrInAppMojPlus = [ProductSourceInfo.MJ, ProductSourceInfo.MA_MJ];
export const arrProductSource2eChance = [ProductSourceInfo.PR, ProductSourceInfo.MP];

// Retourne le "product source" passé dans l'URL si valide sinon "null"
export function getProductSourceFromQueryParams() {
  const productSource = getQueryParamsValue(ProductSourceInfo.PRODUCT_SOURCE);

  if (productSource) {
    if (ProductSourceInfo[productSource]) {
      return productSource;
    }
  }

  return null;
}

export function containsProductSource(productSources) {
  const productSource = getProductSourceFromQueryParams();
  return productSource && productSources.includes(productSource);
}

export function isProductSource2eChance() {
  return containsProductSource(arrProductSource2eChance);
}
// verifie si product_source existe. different de la fonction containsProductSource(productSources)
export function isProductSourceInQueryParams(productSources) {
  const productSource = getProductSourceFromQueryParams();
  return productSource && productSources === productSource;
}
